<template>
  <div class="review-container flex1">
    <div class="flex-row justify-content-space-between">
      <p class="bold has-text-size-12">
        {{ name }}
      </p>
      <p class="has-text-size-12 has-text-grey">
        {{ $d(review.created, "numeric") }}
      </p>
    </div>
    <StarRating :rating="review.score" small />
    <p class="review-text" ref="reviewTextRef">
      {{ review.textRating }}
    </p>
  </div>
</template>

<script setup>
import { useCountryStore } from '~~/stores/country';

const countryStore = useCountryStore();

const props = defineProps({
  review: {
    type: Object,
    required: true,
  },
});

const name = computed(() => {
  if (props.review && props.review.lastName && props.review.firstName) {
    if (countryStore.lastNameFirst) {
      return `${props.review.lastName.charAt(0)}. ${props.review.firstName}`;
    } else {
      return `${props.review.firstName} ${props.review.lastName.charAt(0)}.`;
    }
  }
  return "-";
});
</script>

<style scoped lang="scss">
.review-container {
  display: flex;
  flex-direction: column;
  gap: 8px;

  .review-text {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 11px;
    color: var(--gray600);
  }
}
</style>
